import React, { Component } from 'react'
import './AdminGroupDetails.css'
import { BtnPrimary, BtnSecondary, BtnDanger } from '../commons/Buttons'
import { database, storage, ref, get, set, update, storageRef, uploadBytes, getDownloadURL, deleteObject } from '../../firebase'
import Loading from '../commons/Loading'
import Info from './Info.jsx'
import { withRouter } from '../../withRouter'

class AdminGroupDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      title: '',
      mode: '',
      currentCover: null,
      cover: null,
      activity: null,
      delete: null
    }
    this.getData = this.getData.bind(this)
    this.deleteGroup = this.deleteGroup.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }
  componentDidMount () {
    this.getData()
      .then((data) => {
        this.setState({
          title: data.title,
          currentCover: data.cover,
          mode: data.mode
        })
      })
      .catch((err) => console.error(err))
  }
  getData () {
    return new Promise((resolve, reject) => {
      let title, cover, mode
      get(ref(database, 'grupos/index/' + this.props.groupId))
        .then((snap) => {
          title = snap.val().titulo
          cover = snap.val().cover
          mode = snap.val().mode
          return get(ref(database, 'quinielas/modalidades/' + mode))
        })
        .then((snap) => {
          resolve({
            title: title,
            cover: cover,
            mode: snap.val().titulo
          })
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
  onSubmit () {
    this.setState({
      activity: true
    })
    this.uploadCover()
      .then((cover) => {
        return update(ref(database, 'grupos/index/' + this.props.groupId), {
          cover: cover || this.state.currentCover,
          titulo: this.state.title
        })
      })
      .then(() => {
        this.setState({
          activity: null
        })
        this.props.closeModal()
        setTimeout(() => window.location.reload(), 800)
      })
      .catch((err) => {
        console.error(err)
      })
  }
  uploadCover () {
    return new Promise((resolve, reject) => {
      if (this.state.cover) {
        this.state.cover.toBlob((blob) => {
          const coverRef = storageRef(storage, 'grupos/covers/' + this.props.groupId + '.jpg')
          uploadBytes(coverRef, blob)
            .then((snap) => {
              return getDownloadURL(storageRef(storage, snap.metadata.fullPath))
            })
            .then((url) => resolve(url))
            .catch((err) => reject(err))
        }, 'image/jpeg', 0.86)
      } else {
        resolve(null)
      }
    })
  }
  deleteGroup () {
    this.setState({
      activity: true
    })
    const groupId = this.props.groupId
    const updates = {}
    updates['index/' + groupId] = null
    updates['miembros/' + groupId] = null
    updates['mensajes/' + groupId] = null
    updates['log/' + groupId] = null
    updates['puntaje/' + groupId] = null
    updates['resultados/' + groupId] = null
    get(ref(database, 'grupos/miembros/' + groupId))
      .then((snap) => {
        const promises = []
        let count = 0
        snap.forEach((child) => {
          promises[count] = new Promise((resolve, reject) => {
            set(ref(database, 'usuarios/grupos/' + child.key + '/' + groupId), null)
              .then(() => {
                resolve()
              })
              .catch((err) => {
                reject(err)
              })
          })
          count++
        })
        return Promise.all(promises)
      })
      .then(() => {
        deleteObject(storageRef(storage, 'grupos/covers/' + groupId + '.jpg'))
      })
      .then(() => {
        return update(ref(database, 'grupos'), updates)
      })
      .then(() => {
        this.setState({
          activity: null
        })
        this.props.closeModal()
        this.props.history.push('/')
      })
      .catch((err) => {
        console.error(err)
      })
  }
  render () {
    return (
      <div className='admin-group-details'>
        <Info title={this.state.title} mode={this.state.mode} current={this.state.currentCover} handleTitle={(value) => this.setState({ title: value })} handleCover={(value) => this.setState({ cover: value })} />
        <p>Si las cosas no salieron como lo planearon, puedes eliminar el grupo. Toma en cuenta que se eliminará toda la información y resultados del mismo.</p>
        <p><a className={this.state.delete ? 'admin-group-details__delete admin-group-details__delete--active' : 'admin-group-details__delete'} href='#delete' onClick={(ev) => { ev.preventDefault(); this.setState({ delete: true }) }}>Eliminar grupo</a></p>
        {this.state.delete ? <div>
          <p><b>¿Estas seguro de eliminar el grupo?, esta acción no se puede deshacer</b></p>
          <div className='admin-group-details__row'>
            <div className='admin-group-details__col'>
              <BtnSecondary onClick={() => this.setState({ delete: null })}>¡NO!</BtnSecondary>
            </div>
            <div className='admin-group-details__col'>
              <BtnDanger onClick={() => this.deleteGroup()} disabled={this.state.activity}>{this.props.activity ? <Loading /> : 'Si, eliminar'}</BtnDanger>
            </div>
          </div>
        </div> : <div className='admin-group-details__row'>
          <div className='admin-group-details__col'>
            <BtnSecondary onClick={() => this.props.closeModal()}>Cancelar</BtnSecondary>
          </div>
          <div className='admin-group-details__col'>
            <BtnPrimary onClick={() => this.onSubmit()} disabled={!this.state.title || this.state.activity}>{this.state.activity ? <Loading /> : 'Hecho'}</BtnPrimary>
          </div>
        </div>}
      </div>
    )
  }
}

export default withRouter(AdminGroupDetails)
